import React from "react";
import { Link } from "react-router-dom";
import { FiUser, FiStar, FiHome, FiBook, FiVideo } from "react-icons/fi";
import CompareSlider from "./CompareSlider";
import wpsBefore from "../../images/services/WPS_before.webp";
import wpsAfter from "../../images/services/WPS_after.webp";
import retouchBefore from "../../images/Home Page 1 Befor.webp";
import retouchAfter from "../../images/Home Page 1 After.webp";

const services = [
  {
    icon: <FiUser />,
    title: "Culling & Color Correction",
    price: "$0.08",
    unit: "/image",
    link: "/color-correction",
    thumb: (
      <CompareSlider
        firstImage={wpsBefore}
        secondImage={wpsAfter}
        initialSliderPercentage={50}
      />
    ),
  },
  {
    icon: <FiStar />,
    title: "Retouching & Skin Retouching",
    price: "$1.50",
    unit: "/image",
    link: "/retouching",
    thumb: (
      <CompareSlider
        firstImage={retouchBefore}
        secondImage={retouchAfter}
        initialSliderPercentage={50}
      />
    ),
  },
  {
    icon: <FiHome />,
    title: "Real Estate Photo Editing",
    price: "$1.00",
    unit: "/image",
    link: "/real-estate",
    thumb: (
      <CompareSlider
        firstImage="/images/real_estate_before1.jpg"
        secondImage="/images/real_estate_after1.jpg"
        initialSliderPercentage={50}
      />
    ),
  },
  {
    icon: <FiBook />,
    title: "Album Design",
    price: "$0.80",
    unit: "/page",
    link: "/album-editing",
    thumb: (
      <img
        src="/images/Album S1.jpg"
        alt="Album Design"
        className="service-static-img"
      />
    ),
  },
  {
    icon: <FiVideo />,
    title: "Video Editing",
    price: "$25",
    unit: "/project",
    link: "/video-editing",
    thumb: (
      <img
        src="/images/Video Banner.jpg"
        alt="Video Editing"
        className="service-static-img"
      />
    ),
  },
];

const OurServicesGrid = () => {
  return (
    <section className="services-grid-section" id="services-grid">
      <h2 className="services-grid-heading">Our Services</h2>
      <div className="services-grid">
        {services.map((service) => (
          <Link to={service.link} key={service.title} className="service-card">
            <div className="service-card-icon">{service.icon}</div>
            <h3 className="service-card-title">{service.title}</h3>
            <div className="service-card-price-label">Starting at</div>
            <div className="service-card-price">
              {service.price} <span>{service.unit}</span>
            </div>
            <div className="service-card-thumb service-thumb-slider">
              {service.thumb}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default OurServicesGrid;
